<template>
        <div class="column ">
            <h1 class="title is-1 has-text-white-bis">ScenarFab</h1>
            <span class="ariane" v-for="thing in getAriane">
                <a class="fil" @click.prevent="goTo(thing)">{{ thing.label }}</a> /
            </span>
       </div>
</template>

<script>



    export default {
        components:{
        },
        data(){
            return {
            }
        },
        watch: {

        },
        computed: {
            getAriane(){
                return this.$store.getters.getAriane
            }
        },
        methods: {

            goTo(val){

                this.$emit('goTo',val)
            }

        },
        mounted() {
        },
    }

</script>


<style lang="scss">


    .ariane{
        font-size:2em;
    }

    .title{
        font-size:2.25em !important;
        margin-bottom: 5px !important;
    }

</style>